import React from 'react';
export function ArrowLeftIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.02 11.028L7.435 11.01l5.371-5.355a1 1 0 00-1.412-1.416L4.312 11.3a1 1 0 000 1.414L11.37 19.8a1 1 0 101.416-1.412L7.429 13.01l11.587.018a1 1 0 100-2h.004z"
  }));
}